<template>
    <div class="text text-secondary-text" v-bind:class="this.parent">
        <the-text-view :value="articleItem.news_text" />
    </div>
</template>

<script>

    import TheTextView from './TheTextView'

    export default {
        name: 'TheText',
        components: {
            TheTextView
        },
        data() {
            return {
            }
        },

        props: {
            articleItem: {
                type: Object,
                default: () => {}
            },
            parent:String
        },
        created: function() {

        }
    }
</script>

<style lang="scss">
    .text{
        p{
            padding: 10px 0;
            line-height: 1.6;
        }
        &.article{
            padding-left: 60px;
            padding-right: 10px;
        }
    }
</style>